<template>
    <div id="app">
        <div class="router-view-box"><router-view /></div>
        <!-- 底部 -->
        <footer-box></footer-box>
        <float-toolbar></float-toolbar>
    </div>
</template>
<script>
import { postMessage, registerGetMessage } from '@/utils/postMessage.js';
import footerBox from './components/footer-box.vue';
import floatToolbar from './components/float-toolbar.vue';
export default {
    name: 'app',
    data() {
        return {};
    },
    created: function() {
        // 处理父级页面传递的事件
        registerGetMessage(msg => {
            this.$store.commit('SET_TOKEN', msg.content.type);
        });
        // 发送 ready事件
        postMessage('ready', undefined);
    },
    components: {
        footerBox,
        floatToolbar
    }
};
</script>

<style scoped lang="less">
.router-view-box {
    width: 100%;
}
</style>
